 

const jsonArr={ 
  relationship:[
    {
      "relation": "Parent"
    },
    {
      "relation": "Guardian"
    },
    {
      "relation": "Siblings"
    },
    {
      "relation": "Cousins"
    },
    {
      "relation": "Friend"
    },
    {
      "relation": "Colleague"
    }
  ],
  districtData : 
  [
  {
    "districtlabel": "Adilabad (TG)", "state": "Telangana",
    "District": "adilabad",
    "State_Dist": "TS_adilabad"
  },
  {
    "districtlabel": "Alluri Sitharama Raju (AP)", "state": "Andhra Pradesh",
    "District": "alluri_sitharama_raju",
    "State_Dist": "AP_alluri_sitharama_raju"
  },
  {
    "districtlabel": "Anakapalli (AP)", "state": "Andhra Pradesh",
    "District": "anakapalli",
    "State_Dist": "AP_anakapalli"
  },
  {
    "districtlabel": "Anantapuramu (AP)", "state": "Andhra Pradesh",
    "District": "anantapuramu",
    "State_Dist": "AP_anantapuramu"
  },
  {
    "districtlabel": "Annamayya (AP)", "state": "Andhra Pradesh",
    "District": "annamayya",
    "State_Dist": "AP_annamayya"
  },
  {
    "districtlabel": "Bapatla (AP)", "state": "Andhra Pradesh",
    "District": "bapatla",
    "State_Dist": "AP_bapatla"
  },
  {
    "districtlabel": "Bhadradri Kothagudem (TG)", "state": "Telangana",
    "District": "bhadradri_kothagudem",
    "State_Dist": "TS_bhadradri_kothagudem"
  },
  {
    "districtlabel": "Chittoor (AP)", "state": "Andhra Pradesh",
    "District": "chittoor",
    "State_Dist": "AP_chittoor"
  },
  {
    "districtlabel": "Dr. B.R. Ambedkar Konaseema (AP)", "state": "Andhra Pradesh",
    "District": "dr_br_ambedkar_konaseema",
    "State_Dist": "AP_dr_br_ambedkar_konaseema"
  },
  {
    "districtlabel": "East Godavari (AP)", "state": "Andhra Pradesh",
    "District": "east_godavari",
    "State_Dist": "AP_east_godavari"
  },
  {
    "districtlabel": "Eluru (AP)", "state": "Andhra Pradesh",
    "District": "eluru",
    "State_Dist": "AP_eluru"
  },
  {
    "districtlabel": "Guntur (AP)", "state": "Andhra Pradesh",
    "District": "guntur",
    "State_Dist": "AP_guntur"
  },
  {
    "districtlabel": "Hanumakonda (TG)", "state": "Telangana",
    "District": "hanumakonda",
    "State_Dist": "TS_hanumakonda"
  },
  {
    "districtlabel": "Hyderabad (TG)", "state": "Telangana",
    "District": "hyderabad",
    "State_Dist": "TS_hyderabad"
  },
  {
    "districtlabel": "Jagtial (TG)", "state": "Telangana",
    "District": "jagtial",
    "State_Dist": "TS_jagtial"
  },
  {
    "districtlabel": "Jangaon (TG)", "state": "Telangana",
    "District": "jangaon",
    "State_Dist": "TS_jangaon"
  },
  {
    "districtlabel": "Jayashankar Bhupalpally (TG)", "state": "Telangana",
    "District": "jayashankar_bhupalpally",
    "State_Dist": "TS_jayashankar_bhupalpally"
  },
  {
    "districtlabel": "Jogulamba Gadwal (TG)", "state": "Telangana",
    "District": "jogulamba_gadwal",
    "State_Dist": "TS_jogulamba_gadwal"
  },
  {
    "districtlabel": "Kakinada (AP)", "state": "Andhra Pradesh",
    "District": "kakinada",
    "State_Dist": "AP_kakinada"
  },
  {
    "districtlabel": "Kamareddy (TG)", "state": "Telangana",
    "District": "kamareddy",
    "State_Dist": "TS_kamareddy"
  },
  {
    "districtlabel": "Karimnagar (TG)", "state": "Telangana",
    "District": "karimnagar",
    "State_Dist": "TS_karimnagar"
  },
  {
    "districtlabel": "Khammam (TG)", "state": "Telangana",
    "District": "khammam",
    "State_Dist": "TS_khammam"
  },
  {
    "districtlabel": "Krishna (AP)", "state": "Andhra Pradesh",
    "District": "krishna",
    "State_Dist": "AP_krishna"
  },
  {
    "districtlabel": "Kumuram Bheem Asifabad (TG)", "state": "Telangana",
    "District": "kumuram_bheem_asifabad",
    "State_Dist": "TS_kumuram_bheem_asifabad"
  },
  {
    "districtlabel": "Kurnool (AP)", "state": "Andhra Pradesh",
    "District": "kurnool",
    "State_Dist": "AP_kurnool"
  },
  {
    "districtlabel": "Mahabubabad (TG)", "state": "Telangana",
    "District": "mahabubabad",
    "State_Dist": "TS_mahabubabad"
  },
  {
    "districtlabel": "Mahabubnagar (TG)", "state": "Telangana",
    "District": "mahabubnagar",
    "State_Dist": "TS_mahabubnagar"
  },
  {
    "districtlabel": "Mancherial (TG)", "state": "Telangana",
    "District": "mancherial",
    "State_Dist": "TS_mancherial"
  },
  {
    "districtlabel": "Medak (TG)", "state": "Telangana",
    "District": "medak",
    "State_Dist": "TS_medak"
  },
  {
    "districtlabel": "Medchal-Malkajgiri (TG)", "state": "Telangana",
    "District": "medchal_malkajgiri",
    "State_Dist": "TS_medchal_malkajgiri"
  },
  {
    "districtlabel": "Mulugu (TG)", "state": "Telangana",
    "District": "mulugu",
    "State_Dist": "TS_mulugu"
  },
  {
    "districtlabel": "NTR (AP)", "state": "Andhra Pradesh",
    "District": "ntr",
    "State_Dist": "AP_ntr"
  },
  {
    "districtlabel": "Nagarkurnool (TG)", "state": "Telangana",
    "District": "nagarkurnool",
    "State_Dist": "TS_nagarkurnool"
  },
  {
    "districtlabel": "Nalgonda (TG)", "state": "Telangana",
    "District": "nalgonda",
    "State_Dist": "TS_nalgonda"
  },
  {
    "districtlabel": "Nandyal (AP)", "state": "Andhra Pradesh",
    "District": "nandyal",
    "State_Dist": "AP_nandyal"
  },
  {
    "districtlabel": "Narayanpet (TG)", "state": "Telangana",
    "District": "narayanpet",
    "State_Dist": "TS_narayanpet"
  },
  {
    "districtlabel": "Nirmal (TG)", "state": "Telangana",
    "District": "nirmal",
    "State_Dist": "TS_nirmal"
  },
  {
    "districtlabel": "Nizamabad (TG)", "state": "Telangana",
    "District": "nizamabad",
    "State_Dist": "TS_nizamabad"
  },
  {
    "districtlabel": "Palnadu (AP)", "state": "Andhra Pradesh",
    "District": "palnadu",
    "State_Dist": "AP_palnadu"
  },
  {
    "districtlabel": "Parvathipuram Manyam (AP)", "state": "Andhra Pradesh",
    "District": "parvathipuram_manyam",
    "State_Dist": "AP_parvathipuram_manyam"
  },
  {
    "districtlabel": "Peddapalli (TG)", "state": "Telangana",
    "District": "peddapalli",
    "State_Dist": "TS_peddapalli"
  },
  {
    "districtlabel": "Prakasam (AP)", "state": "Andhra Pradesh",
    "District": "prakasam",
    "State_Dist": "AP_prakasam"
  },
  {
    "districtlabel": "Rajanna Sircilla (TG)", "state": "Telangana",
    "District": "rajanna_sircilla",
    "State_Dist": "TS_rajanna_sircilla"
  },
  {
    "districtlabel": "Ranga Reddy (TG)", "state": "Telangana",
    "District": "ranga_reddy",
    "State_Dist": "TS_ranga_reddy"
  },
  {
    "districtlabel": "Sangareddy (TG)", "state": "Telangana",
    "District": "sangareddy",
    "State_Dist": "TS_sangareddy"
  },
  {
    "districtlabel": "Siddipet (TG)", "state": "Telangana",
    "District": "siddipet",
    "State_Dist": "TS_siddipet"
  },
  {
    "districtlabel": "Sri Potti Sriramulu Nellore (AP)", "state": "Andhra Pradesh",
    "District": "sri_potti_sriramulu_nellore",
    "State_Dist": "AP_sri_potti_sriramulu_nellore"
  },
  {
    "districtlabel": "Sri Sathya Sai (AP)", "state": "Andhra Pradesh",
    "District": "sri_sathya_sai",
    "State_Dist": "AP_sri_sathya_sai"
  },
  {
    "districtlabel": "Srikakulam (AP)", "state": "Andhra Pradesh",
    "District": "srikakulam",
    "State_Dist": "AP_srikakulam"
  },
  {
    "districtlabel": "Suryapet (TG)", "state": "Telangana",
    "District": "suryapet",
    "State_Dist": "TS_suryapet"
  },
  {
    "districtlabel": "Tirupati (AP)", "state": "Andhra Pradesh",
    "District": "tirupati",
    "State_Dist": "AP_tirupati"
  },
  {
    "districtlabel": "Vikarabad (TG)", "state": "Telangana",
    "District": "vikarabad",
    "State_Dist": "TS_vikarabad"
  },
  {
    "districtlabel": "Visakhapatnam (AP)", "state": "Andhra Pradesh",
    "District": "visakhapatnam",
    "State_Dist": "AP_visakhapatnam"
  },
  {
    "districtlabel": "Vizianagaram (AP)", "state": "Andhra Pradesh",
    "District": "vizianagaram",
    "State_Dist": "AP_vizianagaram"
  },
  {
    "districtlabel": "Wanaparthy (TG)", "state": "Telangana",
    "District": "wanaparthy",
    "State_Dist": "TS_wanaparthy"
  },
  {
    "districtlabel": "Warangal (TG)", "state": "Telangana",
    "District": "warangal",
    "State_Dist": "TS_warangal"
  },
  {
    "districtlabel": "West Godavari (AP)", "state": "Andhra Pradesh",
    "District": "west_godavari",
    "State_Dist": "AP_west_godavari"
  },
  {
    "districtlabel": "YSR Kadapa (AP)", "state": "Andhra Pradesh",
    "District": "ysr_kadapa",
    "State_Dist": "AP_ysr_kadapa"
  },
  {
    "districtlabel": "Yadadri Bhuvanagiri (TG)", "state": "Telangana",
    "District": "yadadri_bhuvanagiri",
    "State_Dist": "TS_yadadri_bhuvanagiri"
  }
],
  // end of districtData
  states:[{ "state": "Telangana"
  },{ "state": "Andhra Pradesh"
  },{ "state": "Karnataka"
  },{ "state": "Maharashtra"
  },{ "state": "Tamil Nadu"
  },{ "state": "Uttar Pradesh"
  },{ "state": "Arunachal Pradesh"
  },{ "state": "Assam"
  },{ "state": "Bihar"
  },{ "state": "Chhattisgarh"
  },{ "state": "Delhi"
  },{ "state": "Goa"
  },{ "state": "Gujarat"
  },{ "state": "Haryana"
  },{ "state": "Himachal Pradesh"
  },{ "state": "Jharkhand"
  },{ "state": "Kerala"
  },{ "state": "Madhya Pradesh"
  },{ "state": "Manipur"
  },{ "state": "Meghalaya"
  },{ "state": "Mizoram"
  },{ "state": "Nagaland"
  },{ "state": "Odisha"
  },{ "state": "Punjab"
  },{ "state": "Rajasthan"
  },{ "state": "Sikkim"
  },{ "state": "Tripura"
  },{ "state": "Uttarakhand"
  },{ "state": "West Bengal"
  },{ "state": "Other"
  }
],
      countries: [
  {
    "country": "India"
  },{"country": "United Arab Emirates"
  },{"country": "United States"
  },{"country": "Saudi Arabia"
  },{"country": "Canada"
  },{"country": "United Kingdom"
  },{"country": "Afghanistan"
  },{"country": "Albania"
  },{"country": "Algeria"
  },{"country": "Andorra"
  },{"country": "Angola"
  },{"country": "Antigua and Barbuda"
  },{"country": "Argentina"
  },{"country": "Armenia"
  },{"country": "Australia"
  },{"country": "Austria"
  },{"country": "Azerbaijan"
  },{"country": "Bahamas"
  },{"country": "Bahrain"
  },{"country": "Bangladesh"
  },{"country": "Barbados"
  },{"country": "Belarus"
  },{"country": "Belgium"
  },{"country": "Belize"
  },{"country": "Benin"
  },{"country": "Bhutan"
  },{"country": "Bolivia"
  },{"country": "Bosnia and Herzegovina"
  },{"country": "Botswana"
  },{"country": "Brazil"
  },{"country": "Brunei"
  },{"country": "Bulgaria"
  },{"country": "Burkina Faso"
  },{"country": "Burundi"
  },{"country": "Cabo Verde"
  },{"country": "Cambodia"
  },{"country": "Cameroon"
  },{"country": "Central African Republic"
  },{"country": "Chad"
  },{"country": "Chile"
  },{"country": "China"
  },{"country": "Colombia"
  },{"country": "Comoros"
  },{"country": "Congo, Democratic Republic of the"
  },{"country": "Congo, Republic of the"
  },{"country": "Costa Rica"
  },{"country": "Croatia"
  },{"country": "Cuba"
  },{"country": "Cyprus"
  },{"country": "Czech Republic"
  },{"country": "Denmark"
  },{"country": "Djibouti"
  },{"country": "Dominica"
  },{"country": "Dominican Republic"
  },{"country": "Ecuador"
  },{"country": "Egypt"
  },{"country": "El Salvador"
  },{"country": "Equatorial Guinea"
  },{"country": "Eritrea"
  },{"country": "Estonia"
  },{"country": "Eswatini"
  },{"country": "Ethiopia"
  },{"country": "Fiji"
  },{"country": "Finland"
  },{"country": "France"
  },{"country": "Gabon"
  },{"country": "Gambia"
  },{"country": "Georgia"
  },{"country": "Germany"
  },{"country": "Ghana"
  },{"country": "Greece"
  },{"country": "Grenada"
  },{"country": "Guatemala"
  },{"country": "Guinea"
  },{"country": "Guinea-Bissau"
  },{"country": "Guyana"
  },{"country": "Haiti"
  },{"country": "Honduras"
  },{"country": "Hungary"
  },{"country": "Iceland"
  },{"country": "Indonesia"
  },{"country": "Iran"
  },{"country": "Iraq"
  },{"country": "Ireland"
  },{"country": "Israel"
  },{"country": "Italy"
  },{"country": "Ivory Coast"
  },{"country": "Jamaica"
  },{"country": "Japan"
  },{"country": "Jordan"
  },{"country": "Kazakhstan"
  },{"country": "Kenya"
  },{"country": "Kiribati"
  },{"country": "Kuwait"
  },{"country": "Kyrgyzstan"
  },{"country": "Laos"
  },{"country": "Latvia"
  },{"country": "Lebanon"
  },{"country": "Lesotho"
  },{"country": "Liberia"
  },{"country": "Libya"
  },{"country": "Liechtenstein"
  },{"country": "Lithuania"
  },{"country": "Luxembourg"
  },{"country": "Madagascar"
  },{"country": "Malawi"
  },{"country": "Malaysia"
  },{"country": "Maldives"
  },{"country": "Mali"
  },{"country": "Malta"
  },{"country": "Marshall Islands"
  },{"country": "Mauritania"
  },{"country": "Mauritius"
  },{"country": "Mexico"
  },{"country": "Micronesia"
  },{"country": "Moldova"
  },{"country": "Monaco"
  },{"country": "Mongolia"
  },{"country": "Montenegro"
  },{"country": "Morocco"
  },{"country": "Mozambique"
  },{"country": "Myanmar (Burma)"
  },{"country": "Namibia"
  },{"country": "Nauru"
  },{"country": "Nepal"
  },{"country": "Netherlands"
  },{"country": "New Zealand"
  },{"country": "Nicaragua"
  },{"country": "Niger"
  },{"country": "Nigeria"
  },{"country": "North Macedonia"
  },{"country": "Norway"
  },{"country": "Oman"
  },{"country": "Pakistan"
  },{"country": "Palau"
  },{"country": "Palestine"
  },{"country": "Panama"
  },{"country": "Papua New Guinea"
  },{"country": "Paraguay"
  },{"country": "Peru"
  },{"country": "Philippines"
  },{"country": "Poland"
  },{"country": "Portugal"
  },{"country": "Qatar"
  },{"country": "Romania"
  },{"country": "Russia"
  },{"country": "Rwanda"
  },{"country": "Saint Kitts and Nevis"
  },{"country": "Saint Lucia"
  },{"country": "Saint Vincent and the Grenadines"
  },{"country": "Samoa"
  },{"country": "San Marino"
  },{"country": "Sao Tome and Principe"
  },{"country": "Senegal"
  },{"country": "Serbia"
  },{"country": "Seychelles"
  },{"country": "Sierra Leone"
  },{"country": "Singapore"
  },{"country": "Slovakia"
  },{"country": "Slovenia"
  },{"country": "Solomon Islands"
  },{"country": "Somalia"
  },{"country": "South Africa"
  },{"country": "South Korea"
  },{"country": "South Sudan"
  },{"country": "Spain"
  },{"country": "Sri Lanka"
  },{"country": "Sudan"
  },{"country": "Suriname"
  },{"country": "Sweden"
  },{"country": "Switzerland"
  },{"country": "Syria"
  },{"country": "Taiwan"
  },{"country": "Tajikistan"
  },{"country": "Tanzania"
  },{"country": "Thailand"
  },{"country": "Timor-Leste"
  },{"country": "Togo"
  },{"country": "Tonga"
  },{"country": "Trinidad and Tobago"
  },{"country": "Tunisia"
  },{"country": "Turkey"
  },{"country": "Turkmenistan"
  },{"country": "Tuvalu"
  },{"country": "Uganda"
  },{"country": "Ukraine"
  },{"country": "Uruguay"
  },{"country": "Uzbekistan"
  },{"country": "Vanuatu"
  },{"country": "Vatican City"
  },{"country": "Venezuela"
  },{"country": "Vietnam"
  },{"country": "Yemen"
  },{"country": "Zambia"
  },{"country": "Zimbabwe"
  }
],
  casteData:[
  {
    "id": "1",
    "caste": "blacksmith",
    "castelabel": "Kammari (Blacksmith)"
  },
  {
    "id": "2",
    "caste": "bronzesmith",
    "castelabel": "Kanchari (Bronzesmith)"
  },
  {
    "id": "3",
    "caste": "carpenter",
    "castelabel": "Vadla / Vadrangi (Carpenter)"
  },
  {
    "id": "4",
    "caste": "goldsmith",
    "castelabel": "Ausula / Kamsali (Goldsmith)"
  },
  {
    "id": "5",
    "caste": "sculptor",
    "castelabel": "Silpi (Sculptor / Architect)"
  },
  {
    "id": "6",
    "caste": "others",
    "castelabel": "Others"
  }
],
  //end of casteData
  rasiData:[
  { "rasi": "Dhanu / Dhanuvu (Sagittarius)" },
  { "rasi": "Kanya (Virgo)" },
  { "rasi": "Karkataka (Cancer)" },
  { "rasi": "Kumbha (Aquarius)" },
  { "rasi": "Makara (Capricorn)" },
  { "rasi": "Meena (Pisces)" },
  { "rasi": "Mesha (Aries)" },
  { "rasi": "Mithuna (Gemini)" },
  { "rasi": "Simha (Leo)" },
  { "rasi": "Tula (Libra)" },
  { "rasi": "Vrischika (Scorpio)" },
  { "rasi": "Vrishabha (Taurus)" }
],
// end of rasiData
  nakshatrasData: [
  { "nakshatra": "Anuradha" },
  { "nakshatra": "Ardra" },
  { "nakshatra": "Ashlesha" },
  { "nakshatra": "Ashwini" },
  { "nakshatra": "Bharani" },
  { "nakshatra": "Chitra" },
  { "nakshatra": "Dhanishta" },
  { "nakshatra": "Hasta" },
  { "nakshatra": "Jyeshta" },
  { "nakshatra": "Krittika" },
  { "nakshatra": "Magha" },
  { "nakshatra": "Mrigashira" },
  { "nakshatra": "Mula" },
  { "nakshatra": "Punarvasu" },
  { "nakshatra": "Purva Ashadha" },
  { "nakshatra": "Purva Bhadrapada" },
  { "nakshatra": "Purva Phalguni" },
  { "nakshatra": "Pushya" },
  { "nakshatra": "Revati" },
  { "nakshatra": "Rohini" },
  { "nakshatra": "Shatabhisha" },
  { "nakshatra": "Shravana" },
  { "nakshatra": "Swati" },
  { "nakshatra": "Uttara Ashadha" },
  { "nakshatra": "Uttara Bhadrapada" },
  { "nakshatra": "Uttara Phalguni" },
  { "nakshatra": "Vishakha" }
],
// end of nakshatrasData
   heightData :[
  {
    "heightlabel": "4' 8\" (142 cm)",
    "height": "4'8",
    "heightsearch": "48"
  },
  {
    "heightlabel": "4' 9\" (144 cm)",
    "height": "4'9",
    "heightsearch": "49"
  },
  {
    "heightlabel": "4' 10\" (147 cm)",
    "height": "4'10",
    "heightsearch": "410"
  },
  {
    "heightlabel": "4' 11\" (149 cm)",
    "height": "4'11",
    "heightsearch": "411"
  },
  {
    "heightlabel": "5' 0\" (152 cm)",
    "height": "5'0",
    "heightsearch": "50"
  },
  {
    "heightlabel": "5' 1\" (154 cm)",
    "height": "5'1",
    "heightsearch": "51"
  },
  {
    "heightlabel": "5' 2\" (157 cm)",
    "height": "5'2",
    "heightsearch": "52"
  },
  {
    "heightlabel": "5' 3\" (160 cm)",
    "height": "5'3",
    "heightsearch": "53"
  },
  {
    "heightlabel": "5' 4\" (162 cm)",
    "height": "5'4",
    "heightsearch": "54"
  },
  {
    "heightlabel": "5' 5\" (165 cm)",
    "height": "5'5",
    "heightsearch": "55"
  },
  {
    "heightlabel": "5' 6\" (167 cm)",
    "height": "5'6",
    "heightsearch": "56"
  },
  {
    "heightlabel": "5' 7\" (170 cm)",
    "height": "5'7",
    "heightsearch": "57"
  },
  {
    "heightlabel": "5' 8\" (172 cm)",
    "height": "5'8",
    "heightsearch": "58"
  },
  {
    "heightlabel": "5' 9\" (175 cm)",
    "height": "5'9",
    "heightsearch": "59"
  },
  {
    "heightlabel": "5' 10\" (177 cm)",
    "height": "5'10",
    "heightsearch": "510"
  },
  {
    "heightlabel": "5' 11\" (180 cm)",
    "height": "5'11",
    "heightsearch": "511"
  },
  {
    "heightlabel": "6' 0\" (182 cm)",
    "height": "6'0",
    "heightsearch": "60"
  },
  {
    "heightlabel": "6' 1\" (185 cm)",
    "height": "6'1",
    "heightsearch": "61"
  },
  {
    "heightlabel": "6' 2\" (187 cm)",
    "height": "6'2",
    "heightsearch": "62"
  },
  {
    "heightlabel": "6' 3\" (190 cm)",
    "height": "6'3",
    "heightsearch": "63"
  },
  {
    "heightlabel": "6' 4\" (193 cm)",
    "height": "6'4",
    "heightsearch": "64"
  }
],
  //  end of heightData
  educationCourseData: [
  { "course": "BTech" },
  { "course": "BSc" },
  { "course": "BCom" },
  { "course": "MCA" },
  { "course": "MBBS" },
  { "course": "MBA" },
  { "course": "Intermediate (12th)" },
  { "course": "BA" },
  { "course": "BAMS" },
  { "course": "BBA" },
  { "course": "BCA" },
  { "course": "BDS" },
  { "course": "B.Arch" },
  { "course": "B.E." },
  { "course": "B.Ed" },
  { "course": "BHMS" },
  { "course": "BPharm" },
  { "course": "BSc Agriculture" },
  { "course": "BSc Nursing" },
  { "course": "Bachelor Degree (General)" },
  { "course": "CA" },
  { "course": "CFA" },
  { "course": "CMA" },
  { "course": "CS" },
  { "course": "Diploma" },
  { "course": "DM" },
  { "course": "Doctorate" },
  { "course": "High School (10th)" },
  { "course": "ICWA" },
  { "course": "ITI" },
  { "course": "LLB" },
  { "course": "M.Ch" },
  { "course": "M.E." },
  { "course": "M.Ed" },
  { "course": "M.Pharm" },
  { "course": "M.Sc" },
  { "course": "M.Sc Agri" },
  { "course": "M.Sc Nursing" },
  { "course": "Master Degree (General)" },
  { "course": "MDS" },
  { "course": "Middle School" },
  { "course": "MPT" },
  { "course": "MSW" },
  { "course": "MTech" },
  { "course": "PG Diploma" },
  { "course": "PhD" },
  { "course": "Pursuing PG" },
  { "course": "Pursuing UG" },
  { "course": "Uneducated" },
  { "course": "Other" }
],
  //end of educationCourseData
  occupationData:  [
  { "occupation": "Software Engineer" },
  { "occupation": "IT Professional" },
  { "occupation": "Government Employee" },
  { "occupation": "Business Owner / Entrepreneur" },
  { "occupation": "Doctor (MBBS)" },
  { "occupation": "Goldsmith / Jeweller" },
  { "occupation": "Engineer (General)" },
  { "occupation": "Teacher" },
  { "occupation": "Banker" },
  { "occupation": "Homemaker" },
  { "occupation": "Academician" },
  { "occupation": "Accountant" },
  { "occupation": "Actor / Actress" },
  { "occupation": "Aeronautical Engineer" },
  { "occupation": "Agriculturalist" },
  { "occupation": "Air Hostess / Flight Attendant" },
  { "occupation": "Artist" },
  { "occupation": "Auditor" },
  { "occupation": "Ayurvedic / Homeopathic Doctor" },
  { "occupation": "Bank Officer" },
  { "occupation": "Blacksmith / Metalworker" },
  { "occupation": "Cabin Crew" },
  { "occupation": "Carpenter / Woodworker" },
  { "occupation": "Chartered Accountant (CA)" },
  { "occupation": "Chef" },
  { "occupation": "Chemical Engineer" },
  { "occupation": "Civil Engineer" },
  { "occupation": "Civil Services Officer (IAS/IPS)" },
  { "occupation": "Company Secretary (CS)" },
  { "occupation": "Computer / Hardware Engineer" },
  { "occupation": "Consultant" },
  { "occupation": "Content Creator / Influencer" },
  { "occupation": "Cost Accountant (ICWA/CMA)" },
  { "occupation": "Dairy Farmer" },
  { "occupation": "Data Analyst / Scientist" },
  { "occupation": "Defense Officer (Army/Navy/Air Force)" },
  { "occupation": "Delivery Executive" },
  { "occupation": "Dentist" },
  { "occupation": "Driver" },
  { "occupation": "Electrical Engineer" },
  { "occupation": "Electrician" },
  { "occupation": "Factory / Technical Worker" },
  { "occupation": "Farmer / Landowner" },
  { "occupation": "Film Director / Producer" },
  { "occupation": "Financial Analyst" },
  { "occupation": "Freelancer" },
  { "occupation": "Guard / Security" },
  { "occupation": "HR Professional" },
  { "occupation": "Hotel / Retail Manager" },
  { "occupation": "Investment Banker" },
  { "occupation": "Journalist / Media Professional" },
  { "occupation": "Judge" },
  { "occupation": "Lawyer / Advocate" },
  { "occupation": "Lecturer / Professor" },
  { "occupation": "Legal Advisor" },
  { "occupation": "Marketing Manager" },
  { "occupation": "Mechanical Engineer" },
  { "occupation": "Mechanic" },
  { "occupation": "Musician / Singer / Dancer" },
  { "occupation": "Nurse" },
  { "occupation": "Pharmacist" },
  { "occupation": "Physician" },
  { "occupation": "Physiotherapist" },
  { "occupation": "Pilot" },
  { "occupation": "Plumber" },
  { "occupation": "Police Officer" },
  { "occupation": "Post Office / Railway Employee" },
  { "occupation": "Real Estate Builder / Agent" },
  { "occupation": "Restaurant / Shop Owner" },
  { "occupation": "Retired" },
  { "occupation": "Sales Executive" },
  { "occupation": "Salesman / Salesgirl" },
  { "occupation": "School Principal" },
  { "occupation": "Sculptor / Architect (Silpi)" },
  { "occupation": "Shipping Professional" },
  { "occupation": "Student" },
  { "occupation": "Surgeon" },
  { "occupation": "Technician" },
  { "occupation": "Tele-caller" },
  { "occupation": "Trader / Merchant" },
  { "occupation": "Tutor" },
  { "occupation": "Unemployed" },
  { "occupation": "Veterinarian" },
  { "occupation": "Welder" },
  { "occupation": "Other" }
],
  //end of occupation
  jobLocationsData: [
  { "location": "Hyderabad" },
  { "location": "Bengaluru" },
  { "location": "USA" },
  { "location": "UAE" },
  { "location": "UK" },
  { "location": "Canada" },
  { "location": "Chennai" },
  { "location": "Visakhapatnam (Vizag)" },
  { "location": "Vijayawada" },
  { "location": "Guntur" },
  { "location": "Tirupati" },
  { "location": "Warangal" },
  { "location": "Nellore" },
  { "location": "Ahmedabad" },
  { "location": "Australia" },
  { "location": "Bahrain" },
  { "location": "Bhopal" },
  { "location": "Bhubaneswar" },
  { "location": "Chandigarh" },
  { "location": "Coimbatore" },
  { "location": "Dehradun" },
  { "location": "Delhi-NCR (incl. Gurugram, Noida)" },
  { "location": "France" },
  { "location": "Germany" },
  { "location": "Goa" },
  { "location": "Guwahati" },
  { "location": "Indore" },
  { "location": "Ireland" },
  { "location": "Jaipur" },
  { "location": "Japan" },
  { "location": "Kochi" },
  { "location": "Kolkata" },
  { "location": "Kuwait" },
  { "location": "Lucknow" },
  { "location": "Malaysia" },
  { "location": "Mangaluru" },
  { "location": "Mumbai" },
  { "location": "Mysuru" },
  { "location": "Nagpur" },
  { "location": "Nashik" },
  { "location": "Netherlands" },
  { "location": "New Zealand" },
  { "location": "Oman" },
  { "location": "Patna" },
  { "location": "Pune" },
  { "location": "Qatar" },
  { "location": "Raipur" },
  { "location": "Ranchi" },
  { "location": "Saudi Arabia" },
  { "location": "Singapore" },
  { "location": "Surat" },
  { "location": "Thiruvananthapuram" },
  { "location": "Tiruppur" },
  { "location": "Vadodara" },
  { "location": "Other" }
],
  // end of jobLocations
  salaryData:[
  { "salary": "Under 3 Lakhs" },
  { "salary": "3 - 5 Lakhs" },
  { "salary": "5 - 7 Lakhs" },
  { "salary": "7 - 10 Lakhs" },
  { "salary": "10 - 15 Lakhs" },
  { "salary": "15 - 20 Lakhs" },
  { "salary": "20 - 25 Lakhs" },
  { "salary": "25 - 35 Lakhs" },
  { "salary": "35 - 50 Lakhs" },
  { "salary": "50 - 75 Lakhs" },
  { "salary": "75 Lakhs - 1 Crore" },
  { "salary": "1 - 1.5 Crores" },
  { "salary": "1.5 - 2 Crores" },
  { "salary": "Above 2 Crores" }
]
}

  export default jsonArr
  

  // 1 relationship
  // 2 districtData
  // 3 casteData
  // 4 heightData
  // 5 occupationData
  // 6 salaryData